import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AccountInfo, InteractionRequiredAuthError, RedirectRequest } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { TAI_API_SCOPES } from './auth.config';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly msal = inject(MsalService);
  private readonly router = inject(Router);
  private readonly accountSignal = signal<AccountInfo | null>(null);
  readonly account = this.accountSignal.asReadonly();
  readonly displayName = computed(() => this.accountSignal()?.name ?? this.accountSignal()?.username ?? 'Usuário TAI');

  initializeAccount(): void {
    let account = this.msal.instance.getActiveAccount();
    if (!account) account = this.msal.instance.getAllAccounts()[0] ?? null;
    if (account) this.msal.instance.setActiveAccount(account);
    this.accountSignal.set(account);
  }

  login(): void {
    this.msal.loginRedirect({ scopes: TAI_API_SCOPES } as RedirectRequest).subscribe();
  }

  logout(): void {
    this.msal.logoutRedirect({ postLogoutRedirectUri: `${window.location.origin}/login` }).subscribe();
  }

  getActiveAccount(): AccountInfo | null { this.initializeAccount(); return this.accountSignal(); }
  isAuthenticated(): boolean { return this.getActiveAccount() !== null; }

  async acquireAccessToken(): Promise<string> {
    const account = this.getActiveAccount();
    if (!account) { await this.router.navigate(['/login']); throw new Error('Sessão expirada. Entre novamente.'); }
    try {
      const result = await firstValueFrom(this.msal.acquireTokenSilent({ account, scopes: TAI_API_SCOPES }));
      return result.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) this.login();
      throw error;
    }
  }
}
